// eslint-disable

import { useQuery } from '@tanstack/react-query'
import { Pagination } from 'src/components/datagrid'
import { format } from 'date-fns'

import axiosInstance from 'src/utils/axios'

async function fetchUser(pagination: Pagination, filters: any): Promise<any[]> {
  let sortName: any = 'createdAt'
  let order: string = 'desc'

  if (pagination.sort) {
    const keyNames = Object.keys(pagination.sort)
    sortName = keyNames[0]
    order = pagination.sort[sortName]
  }

  const res = await axiosInstance.get('/product/sales', {
    params: {
      ...pagination,
      sort: sortName,
      order: order === 'desc' ? -1 : 1,
      event: filters?.event?.value,
      dateStart: filters?.dateStart
        ? format(filters.dateStart, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
        : undefined,
      dateEnd: filters?.dateEnd
        ? format(filters.dateEnd, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
        : undefined,
      saler: filters?.salers?.length > 0 ? filters.salers[0]?.value : undefined,
      terminalSerial: filters?.terminalSerial || undefined,
      includeInactive: filters?.includeInactive ? true : undefined,
      categories:
        filters?.categories?.length > 0
          ? filters.categories.map((c: any) => c?.value).filter(Boolean)
          : undefined,
    },
  })
  return res.data
}

function useReports(pagination: Pagination, filters?: any) {
  return useQuery(['reports', pagination, filters], () => fetchUser(pagination, filters), {
    keepPreviousData: true,
    staleTime: 5000,
  })
}

export default useReports
